import { Controller } from '@hotwired/stimulus'

declare const $: (selector: string | HTMLElement) => any

export default class ArchiveConfirmController extends Controller {
  static targets = ['archiveModal', 'reactivateModal', 'warning', 'archiveConfirmBody', 'reactivateConfirmBody']

  declare readonly archiveModalTarget: HTMLElement
  declare readonly reactivateModalTarget: HTMLElement
  declare readonly warningTarget: HTMLElement
  declare readonly hasWarningTarget: boolean
  declare readonly archiveConfirmBodyTarget: HTMLElement
  declare readonly hasArchiveConfirmBodyTarget: boolean
  declare readonly reactivateConfirmBodyTarget: HTMLElement
  declare readonly hasReactivateConfirmBodyTarget: boolean

  private pendingUrl: string = ''

  openArchive (event: Event): void {
    event.preventDefault()
    event.stopPropagation()
    const trigger = event.currentTarget as HTMLElement
    this.pendingUrl = trigger.dataset.archiveConfirmUrlParam ?? ''
    const hasActiveLogs = trigger.dataset.archiveConfirmHasActiveLogsParam === 'true'
    if (this.hasWarningTarget) {
      this.warningTarget.style.display = hasActiveLogs ? '' : 'none'
    }
    if (this.hasArchiveConfirmBodyTarget) {
      const name = trigger.dataset.entityName ?? ''
      const template = this.archiveConfirmBodyTarget.dataset.template ?? ''
      this.archiveConfirmBodyTarget.textContent = template.replace('%name%', name)
    }
    $(this.archiveModalTarget).modal('show')
  }

  confirmArchive (): void {
    window.location.href = this.pendingUrl
  }

  openReactivate (event: Event): void {
    event.preventDefault()
    event.stopPropagation()
    const trigger = event.currentTarget as HTMLElement
    this.pendingUrl = trigger.dataset.archiveConfirmUrlParam ?? ''
    if (this.hasReactivateConfirmBodyTarget) {
      const name = trigger.dataset.entityName ?? ''
      const template = this.reactivateConfirmBodyTarget.dataset.template ?? ''
      this.reactivateConfirmBodyTarget.textContent = template.replace('%name%', name)
    }
    $(this.reactivateModalTarget).modal('show')
  }

  confirmReactivate (): void {
    window.location.href = this.pendingUrl
  }
}
